import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { HrFormTextareaComponent } from './hr-form-textarea.component';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';

@NgModule({
    declarations: [HrFormTextareaComponent],
    imports: [
        CommonModule,
        ToolbarModule,
        TranslateModule,
        HvlFormItemModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        PrimengSharedModule,
    ],
    exports: [HrFormTextareaComponent],
})
export class HrFormTextareaModule {}
